import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'unsubscribe';
export const isUnsubscribeLoadingSelector = isLoadingSelector(reducerName);
export const isUnsubscribeUpdatedSelector = isUpdatedSelector(reducerName);
export const unsubscribeErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map